import React from 'react';
import {
    Typography,
    Card, 
    CardContent,
} from "@mui/material";

const SinglePatternTable = ({ data, shoeDataAll, nextHand }) => {
    // Get the maximum number of rows by finding the longest column
    const dataArray = Object.values(data);
    const maxRows = Math.max(...dataArray.map((column) => column.length));

    // Calculate the count of 'P', 'T', and 'B' in the data
    const countValues = dataArray.reduce((acc, column) => {
        column.forEach(value => {
            if (value === 'P') acc.P += 1;
            if (value === 'T') acc.T += 1;
            if (value === 'B') acc.B += 1;
        });
        return acc;
    }, { P: 0, T: 0, B: 0 });


    // Function to convert the data to sequential numbers
    const convertToSequentialNumbers = (data) => {
        let sequenceCounter = 1;
        const result = {};
    
        // Iterate over the keys (columns)
        Object.keys(data).forEach((key) => {
        result[key] = data[key].map(() => {
            return (sequenceCounter++).toString();
        });
        });
    
        return result;
    };
    const outputData = convertToSequentialNumbers(data);


    const generateCumulativeCount = (data) => {
        let cumulativeSum = 0;
        let result = {};
    
        Object.keys(data).forEach((key) => {
            cumulativeSum += data[key].length; // Add current array's length to sum
            result[key] = [cumulativeSum]; // Store sum as array
        });
        return result;
    };
    const cumulativeData = generateCumulativeCount(dataArray);


    function transformData(inputData) {
        let cumulativeCount = 0;
        let resultCount = {};
        let resultRange = {};
    
        Object.keys(inputData).forEach((key) => {
            const count = inputData[key].length;
            let min = cumulativeCount + 1;
            let max = cumulativeCount + count;
            cumulativeCount += count;
    
            resultCount[key] = [max];
            resultRange[key] = [{ min, max }];
        });
    
        return resultRange;
    }
    const cumulativeDataA = transformData(dataArray);


    console.log('nextHand',nextHand)
    console.log('cumulativeData',cumulativeDataA)
    return (
        <Card
            style={{
                textAlign: 'center',
                marginBottom: '50px',
                backgroundColor: '#fdfce5',
            }}
        >
            <CardContent>
                {/* Display Counts for 'P', 'T', 'B' */}
                <Typography variant="h6" gutterBottom>
                    <span style={{background:'rgb(245 217 124)',padding:'0 5px'}}>Shoe #:  {shoeDataAll}</span> 
                    | <span style={{color:'#1976d2'}}>P: {countValues.P}</span> 
                    | <span style={{color:'#2e7d32'}}>T: {countValues.T} </span>
                    | <span style={{color:'#d32f2f'}}>B:  {countValues.B}</span>
                </Typography>
                
                <table style={{ borderCollapse: 'collapse', textAlign: 'center', width: '100%' }}>
                    {/* Column Headers */}
                    <thead>
                        <tr>
                            {Object.keys(data).map((key, index) => (
                                <th key={index} style={{ 
                                    border: 'none',
                                    }}>
                                    {key==1 ? key : (nextHand >= cumulativeDataA[key-1][0].min ? key : <>&nbsp;&nbsp;</>)}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* Table Rows */}
                    <tbody>
                        {[...Array(maxRows)].map((_, rowIndex) => (
                            <tr key={rowIndex} style={{ border: 'none' }}>
                                {dataArray.map((values, columnIndex) => {


                                    const value = values[rowIndex] ?? ''; // Get the value or default to empty string
                                    return (
                                        <td
                                            key={columnIndex}
                                            style={{
                                                height: '35px',
                                            }}
                                        >
                                            <span
                                                style={{
                                                    backgroundColor:
                                                        value === 'P' ? '#1976d2' : value === 'B' ? '#d32f2f' : value === 'T' ? '#2e7d32' : '',
                                                    padding: '3px 5px',
                                                    borderRadius: '50%',
                                                    fontSize: '14px',
                                                    color: '#fff',
                                                    display: outputData[columnIndex+1][rowIndex] <= nextHand ? 'inline-block' : 'none' // Hide if greater than nextHand
                                                }}
                                            >
                                                {/* {value} */}
                                                {(outputData[columnIndex+1][rowIndex] <10) ? '0'+outputData[columnIndex+1][rowIndex] : outputData[columnIndex+1][rowIndex]}
                                            </span>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </CardContent>
        </Card>
    );
};

export default SinglePatternTable;
